import { render } from "./OvArchive.vue?vue&type=template&id=474b3d5b&scoped=true"
import script from "./OvArchive.vue?vue&type=script&lang=js"
export * from "./OvArchive.vue?vue&type=script&lang=js"

import "./OvArchive.vue?vue&type=style&index=0&id=474b3d5b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-474b3d5b"]])

export default __exports__